import { render, staticRenderFns } from "./usageRights.vue?vue&type=template&id=599b662e&"
import script from "./usageRights.vue?vue&type=script&lang=js&"
export * from "./usageRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports